var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { memo } from "react";
var SvgChevronLeft = function SvgChevronLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.293 12.707a1 1 0 0 0 1.414-1.414zM5 8l-.707-.707a1 1 0 0 0 0 1.414zm4.707-3.293a1 1 0 0 0-1.414-1.414zm0 6.586-4-4-1.414 1.414 4 4zm-4-2.586 4-4-1.414-1.414-4 4z"
  })));
};
var Memo = /*#__PURE__*/memo(SvgChevronLeft);
export default Memo;